import { IconRefreshCcw } from '@iwoca/icons';
import { TTermLengthItem } from 'components/Dashboard/ApplicationsTable/Context/ApplicationsTableState.helpers';
import styles from './TermLengthCell.module.css';

type TProps = {
  items: TTermLengthItem[];
};

export const TermLengthCell = ({ items }: TProps) => {
  const rcfItems = items.filter(({ isRCF }) => isRCF);
  const flexiItems = items.filter(({ isRCF }) => !isRCF);

  return (
    <div className={styles.container}>
      {rcfItems.length > 0 && (
        <div>
          {rcfItems.map((item) => (
            <span key={item.term} className={styles.termLength}>
              {item.term}
              <IconRefreshCcw
                data-testid="rcf-icon"
                className={styles.rcfIcon}
                fontSize="14px"
              />
            </span>
          ))}
        </div>
      )}
      {flexiItems.length > 0 && (
        <div>
          {flexiItems.map((item) => (
            <span key={item.term} className={styles.termLength}>
              {item.term}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};
